/**
 * SIMS-6472 — the message shown when a program is not configured for multi-treatment.
 *
 * Lives in its own module because two screens must say the same thing: visit entry
 * (DateCard) and result editing (the Beneficiary profile's list view). A clinician who
 * hits one and then the other should not get two different explanations of the same
 * configuration problem.
 *
 * It names the checkbox — "Multi Treatment Plan", exactly as the program form labels it —
 * because the reader's next action is to go and tick it. `multiTreatmentPlan` defaults to
 * FALSE on a new program, so this is reachable by simply not ticking that box, and the
 * non-multi code paths it used to reach called backend-1 routes that were removed from
 * API Gateway on 2026-07-15.
 *
 * `MULTI_TREATMENT_PLAN_LABEL` below is the program form's own checkbox label. Both
 * messages build on it and the form renders from it, so a rename cannot leave the messages
 * pointing at a control that no longer exists under that name.
 */
export const MULTI_TREATMENT_PLAN_LABEL = "Multi Treatment Plan";

export const MULTI_TREATMENT_REQUIRED = `Visit entry requires a multi-treatment program. Enable ${MULTI_TREATMENT_PLAN_LABEL} in the program configuration to continue.`;

/** The same constraint, phrased for the edit-a-result surface. */
export const MULTI_TREATMENT_REQUIRED_EDIT = `Editing a result requires a multi-treatment program. Enable ${MULTI_TREATMENT_PLAN_LABEL} in the program configuration to continue.`;
